const diagnosisReportStreamCardStyle = () => ({
  imagesArea: {
    paddingBottom: 10
  }
});

export default diagnosisReportStreamCardStyle;
